import { useEffect } from "react";

import dayjs from "dayjs";

import { usePreferences } from "@/api/me";
import i18n from "@/i18n";

/**
 * Mount-once component that flips the active locale to match the user's
 * stored preference. Drives both i18next (UI strings, Intl-based formatters)
 * and the dayjs global locale (chart axes, relative time). Initial paint uses
 * i18n's fallback ("de"); once /me/preferences/ resolves we apply the user's
 * choice. The mismatch flashes on first-ever load per session — acceptable
 * for an SPA.
 */
export function LanguageSync() {
  const { data } = usePreferences();
  useEffect(() => {
    if (!data?.language) return;
    if (i18n.language !== data.language) {
      void i18n.changeLanguage(data.language);
    }
    dayjs.locale(data.language);
  }, [data?.language]);
  return null;
}
